const content = `<b>– csrftoken:</b> Prevents Cross-Site Request Forgery attacks.
<b>– sessionid:</b> Used to track a user session.
<b>– device_token:</b> Used to reduce 2FA logins.

Note: The Google Tag Manager is used on this site. It does not set any cookies, as it only serves as a container for other tags.`

function EssentialCookieInfoEn(props) {
    return (
        <div className="text_2" style={{whiteSpace: "pre-wrap"}} dangerouslySetInnerHTML={{__html: content}}/>
    );
}

export default EssentialCookieInfoEn;
